export type CertificateStatus = 'ACTIVE' | 'INACTIVE' | string

export interface DeviceCertificate {
  certificateId: string
  status: CertificateStatus
  creationDate?: string
}

export interface Device {
  deviceName: string
  siteId: string | null
  deviceType: string | null
  certificates: DeviceCertificate[]
}

export const DEVICE_TYPES = ['forklift', 'plc', 'camera'] as const
export type DeviceType = (typeof DEVICE_TYPES)[number]

export interface IssueDeviceInput {
  deviceName: string
  siteId: string
  deviceType: DeviceType
  enableCredentialsProvider: boolean
}

export interface IssueDeviceResult {
  deviceName: string
  siteId: string
  deviceType: string
  certificateId: string
  certificateArn: string
  certificatePem: string
  privateKey: string
  // 秘密鍵がSSMに保管され、後から再ダウンロードできるか
  privateKeyStored?: boolean
  policyName: string
  endpoint: string
}

// GET /certificates/{certificateId} の応答。
// 秘密鍵は発行時にSSMへ保管したものがあれば含まれる（保管開始前の証明書にはない）
export interface CertificatePemResult {
  certificateId: string
  status: CertificateStatus
  certificatePem: string
  creationDate?: string
  endpoint: string
  privateKeyStored?: boolean
  privateKey?: string
}

export const DEVICE_NAME_PATTERN = /^[a-zA-Z0-9_-]{1,64}$/
export const SITE_ID_PATTERN = /^[a-z0-9][a-z0-9-]{0,30}$/
